import { createRouter, createWebHistory } from "vue-router";
import { authMiddleware } from "@/middlewares/auth";

import Home from "@/views/frontend/pages/home-index.vue";
import Index from "@/views/frontend/pages/index/index.vue";
import Index_2 from "@/views/frontend/pages/index-2/index-2.vue";
import Index_3 from "@/views/frontend/pages/index-3/index-3.vue";
import Index_4 from "@/views/frontend/pages/index-4/index-4.vue";
import Index_5 from "@/views/frontend/pages/index-5/index-5.vue";
import Faq from "@/views/frontend/pages/pages/faq.vue";
import Coming_Soon from "@/views/frontend/pages/pages/coming-soon.vue";
import Maintenance from "@/views/frontend/pages/pages/maintenance.vue";
import Privacy_Policy from "@/views/frontend/pages/pages/privacy-policy.vue";
import Terms_Condition from "@/views/frontend/pages/pages/terms-condition.vue";
import Testimonial from "@/views/frontend/pages/pages/testimonial.vue";
import Our_Team from "@/views/frontend/pages/pages/our-team.vue";
import Gallery from "@/views/frontend/pages/pages/gallery.vue";
import Pricing from "@/views/frontend/pages/pages/pricing.vue";
import Error_404 from "@/views/frontend/pages/pages/error/error-404.vue";
import Error_500 from "@/views/frontend/pages/pages/error/error-500.vue";
import Booking_Payment from "@/views/frontend/pages/pages/booking/booking-payment.vue";
import Booking_Checkout from "@/views/frontend/pages/pages/booking/booking-checkout.vue";
import Booking_Adon from "@/views/frontend/pages/pages/booking/booking-adon.vue";
import Booking_Success from "@/views/frontend/pages/pages/booking/booking-success.vue";
import Booking_Detail from "@/views/frontend/pages/pages/booking/booking-detail.vue";
import BookingContent from "@/views/frontend/pages/pages/booking/booking-content.vue";
import Booking_Index from "@/views/frontend/pages/pages/booking/booking.vue";
import Invoice_Details from "@/views/frontend/pages/pages/booking/invoice-details.vue";
import Reset_Password from "@/views/frontend/pages/pages/auth/reset-password.vue";
import Forgot_Password from "@/views/frontend/pages/pages/auth/forgot-password.vue";
import Register from "@/views/frontend/pages/pages/auth/register.vue";
import CompleteProfile from "@/views/frontend/pages/pages/auth/CompleteProfile.vue";
import Login from "@/views/frontend/pages/pages/auth/login.vue";
import About_Us from "@/views/frontend/pages/pages/about-us/about-us.vue";
import ContactUs from "@/views/frontend/pages/contact-us.vue";
import Listing_Grid from "@/views/frontend/pages/listing/listing-grid/listing-grid.vue";
import Listing_List from "@/views/frontend/pages/listing/listing-list/listing-list.vue";
import Listing_Deatils from "@/views/frontend/pages/listing/listing-details/listing-details.vue";
import Listing_Map from "@/views/frontend/pages/listing/listing-map/listing-map.vue";
import addListing from "@/views/frontend/pages/listing/add-listing.vue";
import BlogList from "@/views/frontend/pages/blog/blog-list.vue";
import BlogGrid from "@/views/frontend/pages/blog/blog-grid.vue";
import BlogDetails from "@/views/frontend/pages/blog/blog-details.vue";
import Blog from "@/views/frontend/pages/blog/blog.vue";
import Listing from "@/views/frontend/pages/listing/listing.vue";
import Pages from "@/views/frontend/pages/pages/pages.vue";
import Authentication from "@/views/frontend/pages/pages/auth/authentication.vue";
import Error from "@/views/frontend/pages/pages/error/error.vue";
import User from "@/views/frontend/pages/user/user.vue";
import UserDashboard from "@/views/frontend/pages/user/user-dashboard.vue";
import UserBookings from "@/views/frontend/pages/user/booking/user-bookings.vue";
import UserBookingUpcoming from "@/views/frontend/pages/user/booking/user-booking-upcoming.vue";
import UserBookingInprogress from "@/views/frontend/pages/user/booking/user-booking-inprogress.vue";
import UserBookingCompletes from "@/views/frontend/pages/user/booking/user-booking-complete.vue";
import UserBookingCancelled from "@/views/frontend/pages/user/booking/user-booking-cancelled.vue";
import UserSettings from "@/views/frontend/pages/user/settings/user-settings.vue";
import UserSecurity from "@/views/frontend/pages/user/settings/user-security.vue";
import UserPreferences from "@/views/frontend/pages/user/settings/user-preferences.vue";
import UserNotifications from "@/views/frontend/pages/user/settings/user-notifications.vue";
import UserIntegration from "@/views/frontend/pages/user/settings/user-integration.vue";
import UserPayment from "@/views/frontend/pages/user/user-payment.vue";
import UserReviews from "@/views/frontend/pages/user/user-reviews.vue";
import UserWishlist from "@/views/frontend/pages/user/user-wishlist.vue";
import UserWallet from "@/views/frontend/pages/user/user-wallet/user-wallet.vue";
import UserMessages from "@/views/frontend/pages/user/user-messages.vue";

// **************  Admin   ************** //
import AdminLogin from "@/views/admin/pages/authentication/admin-login.vue";
import AdminresetPassword from "@/views/admin/pages/authentication/reset-password.vue";
import AdminforgotPassword from "@/views/admin/pages/authentication/forgot-password.vue";
import Adminotp from "@/views/admin/pages/authentication/otp.vue";
import AdminDashboard from "@/views/admin/pages/dashboard/admin-dashboard.vue";

import Tables from "@/views/admin/pages/uiinterface/tables/ui-tables";
import Tables_Basic from "@/views/admin/pages/uiinterface/tables/tables-basic.vue";
import Data_Tables from "@/views/admin/pages/uiinterface/tables/data-tables.vue";
import Chartapex from "@/views/admin/pages/uiinterface/charts/apex/chart-apex.vue";
import Chartc3 from "@/views/admin/pages/uiinterface/charts/c3/chart-c3.vue";
import Chartflot from "@/views/admin/pages/uiinterface/charts/flot/chart-flot.vue";
import Chartjs from "@/views/admin/pages/uiinterface/charts/js/chart-js.vue";
import Chartmorris from "@/views/admin/pages/uiinterface/charts/morris/chart-morris.vue";
import Charts from "@/views/admin/pages/uiinterface/charts/ui-charts.vue";
import Forms from "@/views/admin/pages/uiinterface/forms/ui-forms.vue";
import Formbasicinput from "@/views/admin/pages/uiinterface/forms/form-elements/formbasic/formbasic-input.vue";
import Formcheckboxradios from "@/views/admin/pages/uiinterface/forms/form-elements/form-checkbox-radios.vue";
import Formgridgutters from "@/views/admin/pages/uiinterface/forms/form-elements/form-grid-gutters.vue";
import Formselect from "@/views/admin/pages/uiinterface/forms/form-elements/form-select.vue";
import FormInput from "@/views/admin/pages/uiinterface/forms/form-elements/forminput/form-input.vue";
import Formmask from "@/views/admin/pages/uiinterface/forms/form-elements/formmask/formmask.vue";
import Formfileupload from "@/views/admin/pages/uiinterface/forms/form-elements/formfile-upload.vue";
import FormHorizontal from "@/views/admin/pages/uiinterface/forms/layouts/form-horizontal.vue";
import Formvertical from "@/views/admin/pages/uiinterface/forms/layouts/form-vertical.vue";
import Formfloatinglabels from "@/views/admin/pages/uiinterface/forms/layouts/form-floating-labels.vue";
import Formvalidation from "@/views/admin/pages/uiinterface/forms/form-validation.vue";
import Formselect2 from "@/views/admin/pages/uiinterface/forms/form-select2.vue";
import Formwizard from "@/views/admin/pages/uiinterface/forms/form-wizard.vue";
import FormPickers from "@/views/admin/pages/uiinterface/forms/form-pickers.vue";
import Advancedui from "@/views/admin/pages/uiinterface/advancedUI/advanced-ui.vue";
import UI_Ribbon from "@/views/admin/pages/uiinterface/advancedUI/ui-ribbon.vue";
import UI_Clipboard from "@/views/admin/pages/uiinterface/advancedUI/ui-clipboard.vue";
import UI_Drag_Drop from "@/views/admin/pages/uiinterface/advancedUI/ui-drag-drop.vue";
import UI_Text_Editor from "@/views/admin/pages/uiinterface/advancedUI/ui-text-editor.vue";
import UI_Counter from "@/views/admin/pages/uiinterface/advancedUI/ui-counter.vue";
import UI_Scrollbar from "@/views/admin/pages/uiinterface/advancedUI/ui-scrollbar.vue";
import UI_Rating from "@/views/admin/pages/uiinterface/advancedUI/ui-rating.vue";
import UI_Stickynote from "@/views/admin/pages/uiinterface/advancedUI/ui-stickynote.vue";
import UI_Timeline from "@/views/admin/pages/uiinterface/advancedUI/ui-timeline.vue";
import BaseUi from "@/views/admin/pages/uiinterface/baseui/base-ui.vue";
import UI_Alerts from "@/views/admin/pages/uiinterface/baseui/ui-alerts.vue";
import UI_Accordion from "@/views/admin/pages/uiinterface/baseui/ui-accordion.vue";
import UI_Avatar from "@/views/admin/pages/uiinterface/baseui/ui-avatar.vue";
import UI_Badges from "@/views/admin/pages/uiinterface/baseui/ui-badges.vue";
import UI_Borders from "@/views/admin/pages/uiinterface/baseui/ui-borders.vue";
import UI_Buttons from "@/views/admin/pages/uiinterface/baseui/ui-buttons.vue";
import UI_Buttons_group from "@/views/admin/pages/uiinterface/baseui/ui-buttons-group.vue";
import UI_Breadcrumb from "@/views/admin/pages/uiinterface/baseui/ui-breadcrumb.vue";
import UI_Cards from "@/views/admin/pages/uiinterface/baseui/ui-cards.vue";
import UI_Carousel from "@/views/admin/pages/uiinterface/baseui/carousel/ui-carousel.vue";
import UI_Colors from "@/views/admin/pages/uiinterface/baseui/ui-colors.vue";
import UI_Dropdowns from "@/views/admin/pages/uiinterface/baseui/ui-dropdowns.vue";
import UI_Grid from "@/views/admin/pages/uiinterface/baseui/ui-grid.vue";
import UI_Images from "@/views/admin/pages/uiinterface/baseui/ui-images.vue";
import UI_Lightbox from "@/views/admin/pages/uiinterface/baseui/lightbox/ui-lightbox.vue";
import UI_Media from "@/views/admin/pages/uiinterface/baseui/ui-media.vue";
import UI_Modals from "@/views/admin/pages/uiinterface/baseui/ui-modals.vue";
import UI_Offcanvas from "@/views/admin/pages/uiinterface/baseui/ui-offcanvas.vue";
import UI_Pagination from "@/views/admin/pages/uiinterface/baseui/ui-pagination.vue";
import UI_Popovers from "@/views/admin/pages/uiinterface/baseui/ui-popovers.vue";
import UI_Progress from "@/views/admin/pages/uiinterface/baseui/ui-progress.vue";
import UI_Placeholders from "@/views/admin/pages/uiinterface/baseui/ui-placeholders.vue";
import UI_Rangeslider from "@/views/admin/pages/uiinterface/baseui/ui-rangeslider.vue";
import UI_navTabs from "@/views/admin/pages/uiinterface/baseui/ui-nav-tabs.vue";
import UI_Spinner from "@/views/admin/pages/uiinterface/baseui/ui-spinner.vue";
import UI_Sortable from "@/views/admin/pages/uiinterface/baseui/ui-sortable.vue";
import UI_Sweetalerts from "@/views/admin/pages/uiinterface/baseui/ui-sweetalerts.vue";
import UI_Tooltips from "@/views/admin/pages/uiinterface/baseui/ui-tooltips.vue";
import UI_Typography from "@/views/admin/pages/uiinterface/baseui/ui-typography.vue";
import UI_Video from "@/views/admin/pages/uiinterface/baseui/ui-video.vue";
import Icons from "@/views/admin/pages/uiinterface/icons/ui-icons.vue";
import UI_Iconfontawesome from "@/views/admin/pages/uiinterface/icons/icon-fontawesome.vue";
import UI_Iconfeather from "@/views/admin/pages/uiinterface/icons/icon-feather.vue";
import UI_Iconionic from "@/views/admin/pages/uiinterface/icons/icon-ionic.vue";
import UI_Iconmaterial from "@/views/admin/pages/uiinterface/icons/icon-material.vue";
import UI_Iconpe7 from "@/views/admin/pages/uiinterface/icons/icon-pe7.vue";
import UI_Iconsimpleline from "@/views/admin/pages/uiinterface/icons/icon-simpleline.vue";
import UI_Iconthemify from "@/views/admin/pages/uiinterface/icons/icon-themify.vue";
import UI_Iconweather from "@/views/admin/pages/uiinterface/icons/icon-weather.vue";
import UI_Icontypicon from "@/views/admin/pages/uiinterface/icons/icon-typicon.vue";
import UI_Iconflag from "@/views/admin/pages/uiinterface/icons/icon-flag.vue";
import iconTabler from "@/views/admin/pages/uiinterface/icons/icon-tabler.vue";
import iconBootstrap from "@/views/admin/pages/uiinterface/icons/icon-bootstrap.vue";
import iconRemix from "@/views/admin/pages/uiinterface/icons/icon-remix.vue";
import Ui_Maps from "@/views/admin/pages/uiinterface/maps/ui-maps.vue";
import MapsVector from "@/views/admin/pages/uiinterface/maps/maps-vector.vue";
import MapsLeaflet from "@/views/admin/pages/uiinterface/maps/maps-leaflet.vue";

import othersSettings from "@/views/admin/pages/settings/other-settings/others-settings.vue";
import sitemap from "@/views/admin/pages/settings/other-settings/sitemap.vue";
import ClearCache from "@/views/admin/pages/settings/other-settings/clear-cache.vue";
import storage from "@/views/admin/pages/settings/other-settings/storage.vue";
import cronjobSettings from "@/views/admin/pages/settings/other-settings/cronjob-settings.vue";
import systemBackup from "@/views/admin/pages/settings/other-settings/system-backup.vue";
import databaseBackup from "@/views/admin/pages/settings/other-settings/database-backup.vue";
import systemUpdate from "@/views/admin/pages/settings/other-settings/system-update.vue";
import financialSettings from "@/views/admin/pages/settings/financial-settings/financial-settings.vue";
import PaymentMethods from "@/views/admin/pages/settings/financial-settings/payment-methods.vue";
import BankAccounts from "@/views/admin/pages/settings/financial-settings/bank-accounts.vue";
import TaxRates from "@/views/admin/pages/settings/financial-settings/tax-rates.vue";
import currencies from "@/views/admin/pages/settings/financial-settings/currencies.vue";
import systemSettings from "@/views/admin/pages/settings/system-settings/system-settings.vue";
import emailSetting from "@/views/admin/pages/settings/system-settings/email-setting.vue";
import emailTemplates from "@/views/admin/pages/settings/system-settings/email-templates.vue";
import smsGateways from "@/views/admin/pages/settings/system-settings/sms-gateways.vue";
import gdprCookies from "@/views/admin/pages/settings/system-settings/gdpr-cookies.vue";
import appSettings from "@/views/admin/pages/settings/app-settings/app-settings.vue";
import invoiceSetting from "@/views/admin/pages/settings/app-settings/invoice-setting.vue";
import invoiceTemplate from "@/views/admin/pages/settings/app-settings/invoice-template.vue";
import signaturesSetting from "@/views/admin/pages/settings/app-settings/signatures-setting.vue";
import customFields from "@/views/admin/pages/settings/app-settings/custom-fields.vue";
import Rental from "@/views/admin/pages/settings/rental-settings/rental.vue";
import RentalSetting from "@/views/admin/pages/settings/rental-settings/rental-setting.vue";
import insuranceSetting from "@/views/admin/pages/settings/rental-settings/insurance-setting.vue";
import accountSettings from "@/views/admin/pages/settings/account-settings/account-settings.vue";
import profileSetting from "@/views/admin/pages/settings/account-settings/profile-setting.vue";
import securitySetting from "@/views/admin/pages/settings/account-settings/security-settings.vue";
import notificationsSetting from "@/views/admin/pages/settings/account-settings/notifications-settings.vue";
import trackerSetting from "@/views/admin/pages/settings/account-settings/tracker-settings.vue";
import integrationsSetting from "@/views/admin/pages/settings/account-settings/integrations-settings.vue";
import websiteSettings from "@/views/admin/pages/settings/website-settings/website-settings.vue";
import companySetting from "@/views/admin/pages/settings/website-settings/company-setting.vue";
import localizationSetting from "@/views/admin/pages/settings/website-settings/localization-setting.vue";
import prefixes from "@/views/admin/pages/settings/website-settings/prefixes.vue";
import seoSetup from "@/views/admin/pages/settings/website-settings/seo-setup.vue";
import languageSetting from "@/views/admin/pages/settings/website-settings/language-setting.vue";
import languageSetting2 from "@/views/admin/pages/settings/website-settings/language-setting2.vue";
import maintenanceMode from "@/views/admin/pages/settings/website-settings/maintenance-mode.vue";
import loginSetting from "@/views/admin/pages/settings/website-settings/login-setting.vue";
import aiConfiguration from "@/views/admin/pages/settings/website-settings/ai-configuration.vue";
import pluginManagers from "@/views/admin/pages/settings/website-settings/plugin-managers.vue";

import Adminreport from "@/views/admin/pages/reports/admin-report.vue";
import incomeReport from "@/views/admin/pages/reports/income-report/income-report.vue";
import earningsReport from "@/views/admin/pages/reports/earnings-report/earnings-report.vue";
import rentalReport from "@/views/admin/pages/reports/rental-report/rental-report.vue";

import adminUser from "@/views/admin/pages/user/admin-user.vue";
import usersList from "@/views/admin/pages/user/users-list.vue";
import rolesPermissions from "@/views/admin/pages/user/roles-permissions.vue";
import Permissions from "@/views/admin/pages/user/permissions.vue";

import adminSupport from "@/views/admin/pages/support/admin-support.vue";
import contactMessages from "@/views/admin/pages/support/contact-messages.vue";
import announcements from "@/views/admin/pages/support/announcements.vue";
import tickets from "@/views/admin/pages/support/tickets.vue";
import ticketsDetails from "@/views/admin/pages/support/tickets-details.vue";

import BookingsIndex from "@/views/admin/pages/bookings/bookings-index.vue";
import ReservationsList from "@/views/admin/pages/bookings/reservation/reservations-list.vue";
import ReservationDetails from "@/views/admin/pages/bookings/reservation/reservation-details.vue";
import AddReservation from "@/views/admin/pages/bookings/reservation/add-reservation/add-reservation.vue";
import EditReservation from "@/views/admin/pages/bookings/reservation/edit-reservation/edit-reservation.vue";
import Calendar from "@/views/admin/pages/bookings/calendar.vue";
import AdminCrm from "@/views/admin/pages/crm/admin-crm.vue";
import AdminPages from "@/views/admin/pages/crm/admin-pages.vue";
import addPages from "@/views/admin/pages/crm/add-pages.vue";
import editPages from "@/views/admin/pages/crm/edit-pages.vue";
import menuManagement from "@/views/admin/pages/crm/menu-management.vue";
import testimonials from "@/views/admin/pages/crm/testimonials.vue";
import AdminBlogs from "@/views/admin/pages/crm/blogs/admin-blogs.vue";
import Blogs from "@/views/admin/pages/crm/blogs/blogs.vue";
import AddBlog from "@/views/admin/pages/crm/blogs/add-blog.vue";
import EditBlog from "@/views/admin/pages/crm/blogs/edit-blog.vue";
import blogCategories from "@/views/admin/pages/crm/blogs/blog-categories.vue";
import blogComments from "@/views/admin/pages/crm/blogs/blog-comments.vue";
import blogTags from "@/views/admin/pages/crm/blogs/blog-tags.vue";
import adminLocations from "@/views/admin/pages/crm/locations/admin-locations.vue";
import adminCountries from "@/views/admin/pages/crm/locations/countries.vue";
import adminState from "@/views/admin/pages/crm/locations/state.vue";
import adminCity from "@/views/admin/pages/crm/locations/city.vue";
import faqAdmin from "@/views/admin/pages/crm/faq/faq.vue";
import faqCategories from "@/views/admin/pages/crm/faq/faq-categories.vue";
import adminFaq from "@/views/admin/pages/crm/faq/admin-faq.vue";
import adminOthers from "@/views/admin/pages/others/others.vue";
import adminFinance from "@/views/admin/pages/finance/finance.vue";
import adminInvoices from "@/views/admin/pages/finance/invoices.vue";
import addInvoice from "@/views/admin/pages/finance/add-invoice.vue";
import editInvoice from "@/views/admin/pages/finance/edit-invoice.vue";
import chatAdmin from "@/views/admin/pages/others/chat.vue";
import Admincoupons from "@/views/admin/pages/others/coupons.vue";
import Adminnewsletters from "@/views/admin/pages/others/newsletters.vue";
import Payments from "@/views/admin/pages/finance/payments.vue";
import adminRental from "@/views/admin/pages/rental/rental.vue";
import Adminreviews from "@/views/admin/pages/rental/reviews.vue";
import Adminmaintenance from "@/views/admin/pages/rental/maintenance.vue";
import Admintracking from "@/views/admin/pages/rental/tracking.vue";
import Admininspections from "@/views/admin/pages/rental/inspections.vue";
import Adminpricing from "@/views/admin/pages/rental/pricing.vue";
import extraServices from "@/views/admin/pages/rental/extra-services.vue";
import carDetails from "@/views/admin/pages/rental/car-details.vue";
import carAttributes from "@/views/admin/pages/rental/car-attributes/car-attributes.vue";
import safetyFeatures from "@/views/admin/pages/rental/car-attributes/safety-features.vue";
import features from "@/views/admin/pages/rental/car-attributes/features.vue";
import doors from "@/views/admin/pages/rental/car-attributes/doors.vue";
import cylinders from "@/views/admin/pages/rental/car-attributes/cylinders.vue";
import seats from "@/views/admin/pages/rental/car-attributes/seats.vue";
import steering from "@/views/admin/pages/rental/car-attributes/steering.vue";
import color from "@/views/admin/pages/rental/car-attributes/color.vue";
import fuel from "@/views/admin/pages/rental/car-attributes/fuel.vue";
import transmissions from "@/views/admin/pages/rental/car-attributes/transmissions.vue";
import types from "@/views/admin/pages/rental/car-attributes/types.vue";
import brands from "@/views/admin/pages/rental/car-attributes/brands.vue";
import models from "@/views/admin/pages/rental/car-attributes/models.vue";
import QuotationsList from "@/views/admin/pages/bookings/quotations/quotations-list.vue";
import AddQuotations from "@/views/admin/pages/bookings/quotations/add-quotations.vue";
import EditQuotations from "@/views/admin/pages/bookings/quotations/edit-quotations.vue";
import QuotationDetails from "@/views/admin/pages/bookings/quotations/quotation-details.vue";
import EnquiriesList from "@/views/admin/pages/bookings/enquiries-list.vue";
import ManageIndex from "@/views/admin/pages/manage/manage-index.vue";
import CustomersList from "@/views/admin/pages/manage/customers-list.vue";
import CustomersCompanies from "@/views/admin/pages/manage/customers-companies.vue";
import CompanyDetails from "@/views/admin/pages/manage/company-details.vue";
import DriversList from "@/views/admin/pages/manage/drivers-list.vue";
import LocationsList from "@/views/admin/pages/manage/locations-list.vue";
import CarsList from "@/views/admin/pages/rental/cars/cars-list.vue";
import AddCar from "@/views/admin/pages/rental/cars/add-car.vue";
import EditCar from "@/views/admin/pages/rental/cars/edit-car.vue";
import InvoiceDetails from "@/views/admin/pages/finance/invoice-details.vue";
import CustomerDetails from "@/views/admin/pages/manage/customer-details.vue";

import SellCar from '@/views/frontend/pages/sell-car/sell-car.vue';
import Services from '@/views/frontend/pages/services/services.vue';
import Favorite from '@/views/frontend/pages/favorite/favorite.vue';


const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: ContactUs,
  },
  {
    path: "/",
    component: Home,
    children: [
      { path: "", redirect: "/index-5" },
      { path: "index-2", component: Index },
      { path: "index-3", component: Index_3 },
      { path: "index-4", component: Index_2 },
      { path: "index", component: Index_4 },
      { path: "Index-5", component: Index_5 },
    ],
  },
  {
    path: "/sell-car",
    component: SellCar,
    name: "sell-car",
    meta: { requiresAuth: true },
 },
  {
    path: "/agency/:id",
    name: "agency-details",
    component: () => import("@/views/frontend/pages/AgencyCars/AgencyCars.vue"),
    props: true
  },
  {
    path: '/services',
    component: Services,
    name: 'services',
    meta: { requiresAuth: true },
 },,
  {
    path: '/favorite',
    component: Favorite,
    name: 'favorite',
    meta: { requiresAuth: true },
 },
  {
    path: "/services",
    component: Services,
    name: "services",
    meta: { requiresAuth: true },
  },
  ,
  {
    path: "/favorite",
    component: Favorite,
    name: "favorite",
    meta: { requiresAuth: true },
  },
  {
    path: "/agency/:id",
    name: "agency-details",
    component: () => import("@/views/frontend/pages/AgencyCars/AgencyCars.vue"),
    props: true,
  },
  {
    path: "/blog",
    component: Blog,
    children: [
      { path: "", redirect: "/blog/blog-list" },
      { path: "blog-list", component: BlogList },
      { path: "blog-grid", component: BlogGrid },
      { path: "blog-details/:id", component: BlogDetails, props: true  }
    ]
 },
 {
  path: '/listing',
  component: Listing,
  children: [
    { path: '', redirect: '/listing/listing-grid' },
    { path: "listing-grid", component: Listing_Grid },
    { path: "listing-list", component: Listing_List },
    { path: "listing-details", component: Listing_Deatils , meta: { requiresAuth: true }},
    { path: ":carId", component: Listing_Deatils , meta: { requiresAuth: true }},
    { path: "listing-map", component: Listing_Map },
    { path: "add-listing", component: addListing }
  ]
},
{
  path: '/pages',
  component: Pages,
  children: [
    { path: '', redirect: '/pages/about-us' },
    { path: "about-us", component: About_Us },
    { path: "pricing", component: Pricing },
    { path: "faq", component: Faq },
    { path: "gallery", component: Gallery },
    { path: "our-team", component: Our_Team },
    { path: "testimonial", component: Testimonial },
    { path: "terms-condition", component: Terms_Condition },
    { path: "privacy-policy", component: Privacy_Policy },
    { path: "maintenance", component: Maintenance },
    { path: "coming-soon", component: Coming_Soon },    
  ]
},

{
  path: '/pages-booking',
  component: Booking_Index,
  children: [
    { path: '', redirect: '/pages-booking/booking-checkout' },
    { path: "booking-checkout", component: Booking_Checkout },
    { path: "booking-addon", component: Booking_Adon },
    { path: "booking-detail", component: Booking_Detail },
    { path: "booking-success", component: Booking_Success },
    { path: "booking-order", component: BookingContent },
    { path: "booking-payment", component: Booking_Payment },
    { path: "invoice-details", component: Invoice_Details}
  ]
},
{
  path: '/authentication',
  component: Authentication,
  children: [
    { path: '', redirect: '/authentication/register' },
    { path: "CompleteProfile", component: CompleteProfile },
    { path: "register", component: Register },
    { path: "forgot-password", component: Forgot_Password},
    { path: "reset-password", component: Reset_Password},
    { path: "Login", component: Login},
  ]
},
{
  path: '/error',
  component: Error,
  children: [
    { path: '', redirect: '/error/error-404' },
    { path: "error-404", component: Error_404 },
    { path: "error-500", component: Error_500 }
  ]
},
{
  path: '/user',
  component: User,
  children: [
    {path: '', redirect: '/user/user-dashboard' },
    {path: 'user-dashboard', component: UserDashboard },
    {path: 'user-bookings', component: UserBookings },
    {path: 'user-booking-upcoming', component: UserBookingUpcoming },
    {path: 'user-booking-inprogress', component: UserBookingInprogress },
    {path: 'user-booking-complete', component: UserBookingCompletes },
    {path: 'user-booking-cancelled', component: UserBookingCancelled },
    {path: 'user-settings', component: UserSettings },
    {path: 'user-security', component: UserSecurity },
    {path: 'user-payment', component: UserPayment },
    {path: 'user-preferences', component: UserPreferences },
    {path: 'user-notifications', component: UserNotifications },
    {path: 'user-integration', component: UserIntegration },
    {path: 'user-reviews', component: UserReviews },
    {path: 'user-wishlist', component: UserWishlist },
    {path: 'user-wallet', component: UserWallet },
    {path: 'user-messages', component: UserMessages },
  ]
},


  // **************  Admin   ************** //

  {
    path: "/admin-template/",
    name: "admin-template/",
    component: AdminLogin,
  },
  {
    path: "/admin-template/reset-password",
    name: "admin-template/reset-password",
    component: AdminresetPassword,
  },
  {
    path: "/admin-template/forgot-password",
    name: "admin-template/forgot-password",
    component: AdminforgotPassword,
  },
  {
    path: "/admin-template/otp",
    name: "admin-template/otp",
    component: Adminotp,
  },
  {
    path: "/admin-template/index",
    name: "admin-template/index",
    component: AdminDashboard,
  },
  {
    path: "/admin-template/bookings",
    component: BookingsIndex,
    children: [
      { path: "", redirect: "/admin-template/bookings/reservations" },
      { path: "reservations", component: ReservationsList },
      { path: "reservation-details", component: ReservationDetails },
      { path: "add-reservation", component: AddReservation },
      { path: "edit-reservation", component: EditReservation },
      { path: "calendar", component: Calendar },
      { path: "quotations", component: QuotationsList },
      { path: "add-quotations", component: AddQuotations },
      { path: "edit-quotations", component: EditQuotations },
      { path: "quotation-details", component: QuotationDetails },
      { path: "enquiries", component: EnquiriesList },
    ],
  },
  {
    path: "/admin-template/manage",
    component: ManageIndex,
    children: [
      { path: "", redirect: "/admin-template/manage/customers" },
      { path: "customers", component: CustomersList },
      { path: "customers-companies", component: CustomersCompanies },
      { path: "company-details", component: CompanyDetails },
      { path: "drivers", component: DriversList },
      { path: "locations", component: LocationsList },
      { path: "customer-details", component: CustomerDetails },
    ],
  },
  {
    path: "/admin-template/icons",
    component: Icons,
    children: [
      { path: "", redirect: "/admin-template/icons/icon-fontawesome" },
      { path: "icon-fontawesome", component: UI_Iconfontawesome },
      { path: "icon-feather", component: UI_Iconfeather },
      { path: "icon-ionic", component: UI_Iconionic },
      { path: "icon-material", component: UI_Iconmaterial },
      { path: "icon-pe7", component: UI_Iconpe7 },
      { path: "icon-simpleline", component: UI_Iconsimpleline },
      { path: "icon-themify", component: UI_Iconthemify },
      { path: "icon-weather", component: UI_Iconweather },
      { path: "icon-typicon", component: UI_Icontypicon },
      { path: "icon-typicon", component: UI_Icontypicon },
      { path: "icon-flag", component: UI_Iconflag },
      { path: "icon-tabler", component: iconTabler },
      { path: "icon-bootstrap", component: iconBootstrap },
      { path: "icon-remix", component: iconRemix },
    ],
  },
  {
    path: "/admin-template/baseui",
    component: BaseUi,
    children: [
      { path: "", redirect: "/admin-template/baseui/ui-alerts" },
      { path: "ui-alerts", component: UI_Alerts },
      { path: "ui-accordion", component: UI_Accordion },
      { path: "ui-avatar", component: UI_Avatar },
      { path: "ui-badges", component: UI_Badges },
      { path: "ui-borders", component: UI_Borders },
      { path: "ui-buttons", component: UI_Buttons },
      { path: "ui-buttons-group", component: UI_Buttons_group },
      { path: "ui-breadcrumb", component: UI_Breadcrumb },
      { path: "ui-cards", component: UI_Cards },
      { path: "ui-carousel", component: UI_Carousel },
      { path: "ui-colors", component: UI_Colors },
      { path: "ui-dropdowns", component: UI_Dropdowns },
      { path: "ui-grid", component: UI_Grid },
      { path: "ui-images", component: UI_Images },
      { path: "ui-lightbox", component: UI_Lightbox },
      { path: "ui-media", component: UI_Media },
      { path: "ui-modals", component: UI_Modals },
      { path: "ui-offcanvas", component: UI_Offcanvas },
      { path: "ui-pagination", component: UI_Pagination },
      { path: "ui-popovers", component: UI_Popovers },
      { path: "ui-progress", component: UI_Progress },
      { path: "ui-placeholders", component: UI_Placeholders },
      { path: "ui-rangeslider", component: UI_Rangeslider },
      { path: "ui-nav-tabs", component: UI_navTabs },
      { path: "ui-spinner", component: UI_Spinner },
      { path: "ui-sortable", component: UI_Sortable },
      { path: "ui-sweetalerts", component: UI_Sweetalerts },
      { path: "ui-tooltips", component: UI_Tooltips },
      { path: "ui-typography", component: UI_Typography },
      { path: "ui-video", component: UI_Video },
    ],
  },
  {
    path: "/admin-template/advancedui",
    component: Advancedui,
    children: [
      { path: "", redirect: "/admin-template/advancedui/ui-ribbon" },
      { path: "ui-ribbon", component: UI_Ribbon },
      { path: "ui-clipboard", component: UI_Clipboard },
      { path: "ui-drag-drop", component: UI_Drag_Drop },
      { path: "ui-text-editor", component: UI_Text_Editor },
      { path: "ui-counter", component: UI_Counter },
      { path: "ui-scrollbar", component: UI_Scrollbar },
      { path: "ui-rating", component: UI_Rating },
      { path: "ui-stickynote", component: UI_Stickynote },
      { path: "ui-timeline", component: UI_Timeline },
    ],
  },
  {
    path: "/admin-template/tables",
    component: Tables,
    children: [
      { path: "", redirect: "/admin-template/tables/data-tables" },
      { path: "data-tables", component: Data_Tables },
      { path: "tables-basic", component: Tables_Basic },
    ],
  },
  {
    path: "/admin-template/charts",
    component: Charts,
    children: [
      { path: "", redirect: "/admin-template/charts/chart-apex" },
      { path: "chart-apex", component: Chartapex },
      { path: "chart-c3", component: Chartc3 },
      { path: "chart-flot", component: Chartflot },
      { path: "chart-js", component: Chartjs },
      { path: "chart-morris", component: Chartmorris },
    ],
  },
  {
    path: "/admin-template/forms",
    component: Forms,
    children: [
      { path: "", redirect: "/admin-template/forms/form-basic-inputs" },
      { path: "form-basic-inputs", component: Formbasicinput },
      { path: "form-checkbox-radios", component: Formcheckboxradios },
      { path: "form-grid-gutters", component: Formgridgutters },
      { path: "form-input-groups", component: FormInput },
      { path: "form-select", component: Formselect },
      { path: "form-mask", component: Formmask },
      { path: "form-fileupload", component: Formfileupload },
      { path: "form-horizontal", component: FormHorizontal },
      { path: "form-vertical", component: Formvertical },
      { path: "form-floating-labels", component: Formfloatinglabels },
      { path: "form-validation", component: Formvalidation },
      { path: "form-select2", component: Formselect2 },
      { path: "form-wizard", component: Formwizard },
      { path: "form-pickers", component: FormPickers },
    ],
  },
  {
    path: "/admin-template/maps",
    component: Ui_Maps,
    children: [
      { path: "", redirect: "/admin-template/maps/maps-vector" },
      { path: "maps-vector", component: MapsVector },
      { path: "maps-leaflet", component: MapsLeaflet },
    ],
  },
  {
    path: "/admin-template/other-settings",
    component: othersSettings,
    children: [
      { path: "", redirect: "/admin-template/other-settings/sitemap" },
      { path: "sitemap", component: sitemap },
      { path: "clear-cache", component: ClearCache },
      { path: "storage", component: storage },
      { path: "cronjob", component: cronjobSettings },
      { path: "system-backup", component: systemBackup },
      { path: "database-backup", component: databaseBackup },
      { path: "system-update", component: systemUpdate },
    ],
  },
  {
    path: "/admin-template/finance-settings",
    component: financialSettings,
    children: [
      {
        path: "",
        redirect: "/admin-template/finance-settings/payment-methods",
      },
      { path: "payment-methods", component: PaymentMethods },
      { path: "bank-accounts", component: BankAccounts },
      { path: "tax-rates", component: TaxRates },
      { path: "currencies", component: currencies },
    ],
  },
  {
    path: "/admin-template/system-settings",
    component: systemSettings,
    children: [
      { path: "", redirect: "/admin-template/system-settings/email-setting" },
      { path: "email-setting", component: emailSetting },
      { path: "email-templates", component: emailTemplates },
      { path: "sms-gateways", component: smsGateways },
      { path: "gdpr-cookies", component: gdprCookies },
    ],
  },
  {
    path: "/admin-template/app-settings",
    component: appSettings,
    children: [
      { path: "", redirect: "/admin-template/app-settings/invoice-setting" },
      { path: "invoice-setting", component: invoiceSetting },
      { path: "invoice-template", component: invoiceTemplate },
      { path: "signatures-setting", component: signaturesSetting },
      { path: "custom-fields", component: customFields },
    ],
  },
  {
    path: "/admin-template/rental-settings",
    component: Rental,
    children: [
      { path: "", redirect: "/admin-template/rental-settings/rental-setting" },
      { path: "rental-setting", component: RentalSetting },
      { path: "insurance-setting", component: insuranceSetting },
    ],
  },
  {
    path: "/admin-template/account-settings",
    component: accountSettings,
    children: [
      {
        path: "",
        redirect: "/admin-template/account-settings/profile-setting",
      },
      { path: "profile-setting", component: profileSetting },
      { path: "security-setting", component: securitySetting },
      { path: "notifications-setting", component: notificationsSetting },
      { path: "tracker-setting", component: trackerSetting },
      { path: "integrations-settings", component: integrationsSetting },
    ],
  },
  {
    path: "/admin-template/website-settings",
    component: websiteSettings,
    children: [
      {
        path: "",
        redirect: "/admin-template/website-settings/company-setting",
      },
      { path: "company-setting", component: companySetting },
      { path: "localization-setting", component: localizationSetting },
      { path: "prefixes", component: prefixes },
      { path: "seo-setup", component: seoSetup },
      { path: "language-setting", component: languageSetting },
      { path: "language-setting2", component: languageSetting2 },
      { path: "maintenance-mode", component: maintenanceMode },
      { path: "login-setting", component: loginSetting },
      { path: "ai-configuration", component: aiConfiguration },
      { path: "plugin-managers", component: pluginManagers },
    ],
  },
  {
    path: "/admin-template/reports",
    component: Adminreport,
    children: [
      { path: "", redirect: "/admin-template/reports/income-report" },
      { path: "income-report", component: incomeReport },
      { path: "earnings-report", component: earningsReport },
      { path: "rental-report", component: rentalReport },
    ],
  },
  {
    path: "/admin-template/users",
    component: adminUser,
    children: [
      { path: "", redirect: "/admin-template/users/users-list" },
      { path: "users-list", component: usersList },
      { path: "roles-permissions", component: rolesPermissions },
      { path: "permissions", component: Permissions },
    ],
  },
  {
    path: "/admin-template/support",
    component: adminSupport,
    children: [
      { path: "", redirect: "/admin-template/support/contact-messages" },
      { path: "contact-messages", component: contactMessages },
      { path: "announcements", component: announcements },
      { path: "tickets", component: tickets },
      { path: "tickets-details", component: ticketsDetails },
    ],
  },
  {
    path: "/admin-template/cms",
    component: AdminCrm,
    children: [
      { path: "", redirect: "/admin-template/cms/pages" },
      { path: "pages", component: AdminPages },
      { path: "add-pages", component: addPages },
      { path: "edit-pages", component: editPages },
      { path: "menu-management", component: menuManagement },
      { path: "testimonials", component: testimonials },
    ],
  },
  {
    path: "/admin-template/blogs",
    component: AdminBlogs,
    children: [
      { path: "", redirect: "/admin-template/blogs/blogs" },
      { path: "blogs", component: Blogs },
      { path: "add-blog", component: AddBlog },
      { path: "edit-blog", component: EditBlog },
      { path: "blog-categories", component: blogCategories },
      { path: "blog-comments", component: blogComments },
      { path: "blog-tags", component: blogTags },
    ],
  },
  {
    path: "/admin-template/locations",
    component: adminLocations,
    children: [
      { path: "", redirect: "/admin-template/blogs/blogs" },
      { path: "countries", component: adminCountries },
      { path: "state", component: adminState },
      { path: "city", component: adminCity },
    ],
  },
  {
    path: "/admin-template/faq",
    component: adminFaq,
    children: [
      { path: "", redirect: "/admin-template/faq/faq" },
      { path: "faq", component: faqAdmin },
      { path: "faq-category", component: faqCategories },
    ],
  },
  {
    path: "/admin-template/others",
    component: adminOthers,
    children: [
      { path: "", redirect: "/admin-template/others/chat" },
      { path: "chat", component: chatAdmin },
      { path: "coupons", component: Admincoupons },
      { path: "newsletters", component: Adminnewsletters },
    ],
  },
  {
    path: "/admin-template/finance",
    component: adminFinance,
    children: [
      { path: "", redirect: "/admin-template/finance/invoices" },
      { path: "invoices", component: adminInvoices },
      { path: "add-invoice", component: addInvoice },
      { path: "edit-invoice", component: editInvoice },
      { path: "payments", component: Payments },
      { path: "invoice-details", component: InvoiceDetails },
    ],
  },
  {
    path: "/admin-template/rentals",
    component: adminRental,
    children: [
      { path: "", redirect: "/admin-template/rentals/reviews" },
      { path: "reviews", component: Adminreviews },
      { path: "maintenance", component: Adminmaintenance },
      { path: "tracking", component: Admintracking },
      { path: "inspections", component: Admininspections },
      { path: "pricing", component: Adminpricing },
      { path: "extra-services", component: extraServices },
      { path: "cars", component: CarsList },
      { path: "add-car", component: AddCar },
      { path: "edit-car", component: EditCar },
      { path: "car-details", component: carDetails },
    ],
  },
  {
    path: "/admin-template/car-attributes",
    component: carAttributes,
    children: [
      { path: "", redirect: "/admin-template/car-attributes/brands" },
      { path: "safety-features", component: safetyFeatures },
      { path: "features", component: features },
      { path: "doors", component: doors },
      { path: "cylinders", component: cylinders },
      { path: "seats", component: seats },
      { path: "steering", component: steering },
      { path: "color", component: color },
      { path: "fuel", component: fuel },
      { path: "transmissions", component: transmissions },
      { path: "models", component: models },
      { path: "types", component: types },
      { path: "brands", component: brands },
    ],
  },
];

export const router = createRouter({
  history: createWebHistory("/vue/template-rtl/"),
  linkActiveClass: "active",
  routes,
});

router.beforeEach((to, from, next) => {
  // Scroll to the top of the page
  window.scrollTo({ top: 0, behavior: "smooth" });
  authMiddleware(to, from, next);
});
